/* globals lp,  editor */
var InvariantsHelper = require('./invariants-helper');
var jQuery = require('jquery');
var _ = require('lodash');

(function() {
  var register = lp.invariants.register
    , helper   = InvariantsHelper;

  var _positionWidgetIndexToPositionMap = [
    'left top',
    'center top',
    'right top',
    'left center',
    'center center',
    'right center',
    'left bottom',
    'center bottom',
    'right bottom'
  ];


  function _checkBackgroundPropsPanelInvariants() {
    var _isBgPropertyApplicable = function(elm) {
      return _.contains([
        helper.elmToTypeMapping().root,
        helper.elmToTypeMapping().block,
        helper.elmToTypeMapping().box
      ], elm.type);
    };

    var _checkStyleType = function(elm, $backgroundPanel) {
      var modelBgType = elm.model.get('style.newBackground.type');
      var panelBgType = $backgroundPanel
        .find("#bg-style-type-select .form-select-input option:selected").val();

      var result = (modelBgType === panelBgType);

      if(result) {
        return [];
      } else {
        return [{
          assertion: result,
          propName: 'bgType',
          modelVal: modelBgType,
          panelVal: panelBgType
        }];
      }
    };

    var _getProperty = function(elm, property) {
      var allProps = _.clone(lp.pom.NewBGPropsHelper.getProperties(elm.model));
      var accessors = property.split('.');
      return _.reduce(accessors, function(result, node, index) {
        if(_.isObject(result) && _.has(result, node)) {
          return result[node];
        } else {
          return index === accessors.length - 1 ? undefined : {};
        }
      }, allProps);
    };

    var _checkPropertyValueAgainstModel = function(propValContainer) {
      return (!_.isUndefined(propValContainer.model) && _.isEqual(propValContainer.model, propValContainer.panel)) ||
        (_.isUndefined(propValContainer.model) && _.isEqual(propValContainer.panel, propValContainer.default));
    };

    var _checkPropertiesAgainstModel = function(array) {
      var testResults = _.map(array, function(propValContainer) {
        return {
          assertion: _checkPropertyValueAgainstModel(propValContainer),
          propName: propValContainer.name,
          modelVal: propValContainer.model,
          panelVal: propValContainer.panel
        };
      });

      var failingTestResults = _.filter(testResults, function(testResult) {
        return !testResult.assertion;
      });

      return failingTestResults;
    };

    var _checkCommonBasicPropsForImgAndPattern = function(elm, $backgroundPanel /*, type */) {
      var propsToCheck = [];

      var modelFilename = _getProperty(elm, 'image.name');
      var panelFilename = $backgroundPanel.find('.asset-chooser .filename').text();

      propsToCheck.push({
        name: 'filename',
        model: modelFilename,
        panel: panelFilename,
        default: "No image specified"
      });

      if (window.editor.page.isDesktopBreakpoint()) {
        var modelParallax = _getProperty(elm, 'parallax');
        var panelParallax = $backgroundPanel.find('.checkbox-input-parallax input.checkbox').is(':checked');

        propsToCheck.push({
          name: 'parallax',
          model: modelParallax,
          panel: panelParallax,
          default: false
        });
      }

      if (_checkStretchToBackgroundProp(elm, $backgroundPanel)) {
        propsToCheck.push(_checkStretchToBackgroundProp(elm, $backgroundPanel));
      }

      return _checkPropertiesAgainstModel(propsToCheck);
    };

    var _checkStretchToBackgroundProp = function(elm, $backgroundPanel /*, type */) {
      if (_.contains([helper.elmToTypeMapping().block], elm.type) && elm.page.allowFitWidthToPage()) {
        var modelFitWidthToPage = _getProperty(elm, 'fitWidthToPage');
        var panelFitWidthToPage = $backgroundPanel
          .find("label[for='fit-width-to-page-checkbox']")
          .siblings(".form-elm-checkbox:first")
          .is(':checked');

        return ({
          name: 'fitWidthToPage',
          model: modelFitWidthToPage,
          panel: panelFitWidthToPage,
          default: false
        });
      }
    };

    var _checkCommonAdvancedPropsforImgAndPattern = function(elm, $advancedBackgroundPanel, type) {
      var propValContainers = [];
      var modelColorOverlay = _getProperty(elm, 'isColorOverImage');
      var panelOverlay = $advancedBackgroundPanel.find(".color-overlay-container .radio-btn-grp .checkbox:checked").siblings('label').text();
      var panelColorOverlay = _.isEqual(panelOverlay, "Overlay") ? true : false;
      propValContainers.push({
        name: 'colorOverlay',
        model: modelColorOverlay,
        panel: panelColorOverlay,
        default: true
      });

      var $bgColorInputElm = $advancedBackgroundPanel.find(".color-input:first .color-input-container input");
      if(!$bgColorInputElm.is(':focus')) {
        var modelBgColor = _getProperty(elm, 'bgColor');
        var panelBgColor = $bgColorInputElm.val();
        propValContainers.push({
          name: 'bgColor',
          model: modelBgColor,
          panel: panelBgColor,
          default: "fff"
        });
      }

      var modelPosition = _getProperty(elm, 'position');
      var panelPositionIndex = $advancedBackgroundPanel
        .find(".form-elm.align-select .align-select a.button.on")
        .index();
      var panelPosition = _positionWidgetIndexToPositionMap[panelPositionIndex];
      propValContainers.push({
        name: 'position',
        model: modelPosition,
        panel: panelPosition,
        default: (type === 'image' ? 'center center' : 'left top')
      });

      var $opacityInputElm = $advancedBackgroundPanel.find('.slider-input input.text.slider');
      if(!$opacityInputElm.is(':focus')) {
        var modelOpacity = _getProperty(elm, 'opacity');
        var panelOpacity = parseInt($opacityInputElm.val());
        propValContainers.push({
          name: 'opacity',
          model: modelOpacity,
          panel: panelOpacity,
          default: 100
        });
      }

      return _checkPropertiesAgainstModel(propValContainers);
    };

    var _checkBasicPropsForPattern = function(elm, $backgroundPanel) {
      return _checkCommonBasicPropsForImgAndPattern(elm, $backgroundPanel, 'pattern');
    };

    var _checkBasicPropsForImage = function(elm, $backgroundPanel) {
      var modelFitToContainer = _getProperty(elm, 'fitToContainer');
      var panelFitToContainer = $backgroundPanel
        .find("label[for='fit-to-container-checkbox']")
        .siblings('input:first')
        .is(":checked");

      return _checkCommonBasicPropsForImgAndPattern(elm, $backgroundPanel, 'image') &&
        _checkPropertiesAgainstModel([{
          name: 'fitToContainer',
          model: modelFitToContainer,
          panel: panelFitToContainer,
          default: false
        }]);
    };

    var _checkBasicPropsForSolidColor = function(elm, $backgroundPanel) {
      var propValContainers = [];

      var $bgColorInputElm = $backgroundPanel.find('.color-input:first .color-input-container input');
      if(!$bgColorInputElm.is(':focus')) {
        var modelBgColor = _getProperty(elm, 'bgColor');
        var panelBgColor = $bgColorInputElm.val();
        propValContainers.push({
          name: 'bgColor',
          model: modelBgColor,
          panel: panelBgColor,
          default: "fff"
        });
      }

      var $opacityInputElm = $backgroundPanel.find('.slider-input input.text.slider');
      if(!$opacityInputElm.is(':focus')) {
        var modelOpacity = _getProperty(elm, 'opacity');
        var panelOpacity = parseInt($opacityInputElm.val());
        propValContainers.push({
          name: 'opacity',
          model: modelOpacity,
          panel: panelOpacity,
          default: 100
        });
      }

      if (_checkStretchToBackgroundProp(elm, $backgroundPanel)) {
        propValContainers.push(_checkStretchToBackgroundProp(elm, $backgroundPanel));
      }

      return _checkPropertiesAgainstModel(propValContainers);
    };

    var _checkBasicPropsForGradient = function(elm, $backgroundPanel) {
      var modelBaseColor = _getProperty(elm, 'baseColor');
      var panelBaseColor = $backgroundPanel.find('.color-input:first .color-input-container input').val();

      var modelFromColor = _getProperty(elm, 'fromColor');
      var panelFromColor = $backgroundPanel.find('.color-input:nth-child(2) .color-input-container input').val();

      var modelToColor = _getProperty(elm, 'toColor');
      var panelToColor = $backgroundPanel.find('.color-input:last .color-input-container input').val();

      var propValContainers = [{
        name: 'baseColor',
        model: modelBaseColor,
        panel: panelBaseColor,
        default: "fff"
      }, {
        name: 'fromColor',
        model: modelFromColor,
        panel: panelFromColor,
        default: "fff"
      }, {
        name: 'toColor',
        model: modelToColor,
        panel: panelToColor,
        default: "e6e6e6"
      }];

      if (_checkStretchToBackgroundProp(elm, $backgroundPanel)) {
        propValContainers.push(_checkStretchToBackgroundProp(elm, $backgroundPanel));
      }

      return _checkPropertiesAgainstModel(propValContainers);
    };

    var _checkAdvancedPropsForImage = function(elm, $advancedBackgroundPanel) {
      return _checkCommonAdvancedPropsforImgAndPattern(elm, $advancedBackgroundPanel, 'image');
    };

    var _checkAdvancedPropsForPattern = function(elm, $advancedBackgroundPanel) {
      var modelTiling = _getProperty(elm, 'tiling');
      var panelTiling = $advancedBackgroundPanel.find('#jui-background-repeat-select select option:selected').val();

      return _checkCommonAdvancedPropsforImgAndPattern(elm, $advancedBackgroundPanel, 'pattern') &&
        _checkPropertiesAgainstModel([{
          name: 'tiling',
          model: modelTiling,
          panel: panelTiling,
          default: 'repeat'
        }]);
    };

    var _checkAdvancedPropsForSolidColor = function() {
      return [];
    };

    var _checkAdvancedPropsForGradient = function() {
      return [];
    };

    var _checkBasicPropsForVideo = function(elm, $backgroundPanel) {
      var $videoUrlField = $backgroundPanel.find('.text-input:first input');

      if ($videoUrlField.is(':focus')) {
        return [];
      } else {
        var modelVideoUrl = _getProperty(elm, 'videoUrl');
        var panelVideoUrl = $videoUrlField.val();

        var fitWidthToPage = _checkStretchToBackgroundProp(elm, $backgroundPanel);

        return _checkPropertiesAgainstModel([{
          name: 'videoUrl',
          model: modelVideoUrl,
          panel: panelVideoUrl,
          default: ''
        },
          fitWidthToPage
        ]);
      }
    };

    var _checkAdvancedPropsForVideo = function() {
      return [];
    };

    var dispatcher = {
      image: {
        basicCheckFn: _checkBasicPropsForImage,
        advancedCheckFn: _checkAdvancedPropsForImage
      },
      pattern: {
        basicCheckFn: _checkBasicPropsForPattern,
        advancedCheckFn: _checkAdvancedPropsForPattern
      },
      solidColor: {
        basicCheckFn: _checkBasicPropsForSolidColor,
        advancedCheckFn: _checkAdvancedPropsForSolidColor
      },
      gradient: {
        basicCheckFn: _checkBasicPropsForGradient,
        advancedCheckFn: _checkAdvancedPropsForGradient
      },
      video: {
        basicCheckFn: _checkBasicPropsForVideo,
        advancedCheckFn: _checkAdvancedPropsForVideo
      }
    };

    var _checkBasicProps = function(elm, $backgroundPanel) {
      var modelBgType = elm.model.get('style.newBackground.type');
      return dispatcher[modelBgType].basicCheckFn(elm, $backgroundPanel);
    };

    var _checkAdvancedProps = function(elm, $advancedBackgroundPanel) {
      var modelBgType = elm.model.get('style.newBackground.type');
      return dispatcher[modelBgType].advancedCheckFn(elm, $advancedBackgroundPanel);
    };

    if (_isBgPropertyApplicable(editor.activeElement)) {
      var $propertiesPanel = jQuery(helper.panelSelectorMapping.properties);
      var $backgroundPanel = $propertiesPanel.find('#bg-style-type-select')
        .parents('.collapsible-panel');

      var $advancedBackgroundPanel = $propertiesPanel.find(".advanced-bg-props-container");

      if (_.isEmpty($backgroundPanel)) {
        return [];
      } else {
        return _.flatten([
          _checkStyleType(editor.activeElement, $backgroundPanel),
          _checkBasicProps(editor.activeElement, $backgroundPanel),
          _checkAdvancedProps(editor.activeElement, $advancedBackgroundPanel)
        ]);
      }
    } else {
      return [];
    }
  }

  register('CheckBackgroundPropsPanelInvariants', function(editor, assert) {
    if (jQuery("#editor-info-panel .tab-bar a.tab:first").hasClass("on")) {
      var failures = _checkBackgroundPropsPanelInvariants();
      var failureMsg = _.reduce(failures, function(msg, testResult) {
        return [
          testResult.propName + "(" + testResult.modelVal + "!=" + testResult.panelVal + ")",
          msg
        ].join(",");
      }, "");

      return assert( _.isEmpty(failures), failureMsg);
    } else {
      return true;
    }
  });
})();



//////////////////
// WEBPACK FOOTER
// ./src/legacy/lp/editor/invariants/background-panel-invariants.js
// module id = 1074
// module chunks = 0